module.exports = __webpack_public_path__ + "img/icon_return.95f51310.png";